import React, { useContext, useEffect, useState } from "react";
import "./Contact_Us.css";
import { Form } from "react-bootstrap";
import Common_Banner from "../common_components/common-banner/Common_Banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faLinkedinIn,
  faFacebookF,
  faXTwitter,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import Get_started from "../home/get_started/Get_started";
import Blue_btn from "../common_components/common_btn/blue_btn/Blue_btn";
import Success_modal from "../common_components/common_modal/success_modal/Success_modal";
import successAnimation from "../animation/success_lottie/Success_lottie.json";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GetInTouch } from "../features/website/Slice";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { Create } from "../features/contact_us/slice";
import { Context } from "../../utils/context";

const Contact_Us = () => {
  const dispatch = useDispatch();
  const [modalSuccessShow, setModalSuccessShow] = useState(false);

  const getInTouch = useSelector(
    (state) => state?.website?.GetSuccessSpeaks?.all_contact_us_get_in_touch,
  );

  const { usertype, language } = useContext(Context);

  useEffect(() => {
    dispatch(GetInTouch({ language }));
  }, [dispatch, language]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  console.log(errors, "errors");

  const onSubmit = async (data) => {
    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("contact_no", data.contact_no);
      formData.append("message", data.message);

      const res = await dispatch(Create(formData));

      if (res?.meta?.requestStatus === "fulfilled") {
        setModalSuccessShow(true);
        reset();
        setTimeout(() => setModalSuccessShow(false), 3000);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Common_Banner
        imgSrc={"assets/images/common-banner/contact-banner.png"}
        title_text={language == 1 ? "Contact Us" : "Contactez-nous"}
      />
      <section className="contact_div">
        <div className="container">
          <div className="row justify-content-center ">
            {/* =========== Left Form =========== */}
            <div className="col-lg-6 p-0 col-md-6">
              <div className="contact_left_div">
                <h2 className="contact_title">
                  {language == 1 ? "Send Us a " : "Envoyez-nous un "}
                  <span>{language == 1 ? "Message" : "message"}</span>
                </h2>
                <p className="contact_subtitle">
                  {language == 1
                    ? "Have a query? Let’s connect. We’re happy to help with internships, study abroad programs or general information."
                    : "Vous avez une question ? Contactons-nous. Nous serons heureux de vous aider pour les stages, les programmes d’études à l’étranger ou toute information générale."}
                </p>
                <div className="contact_form">
                  <Form onSubmit={handleSubmit(onSubmit)}>
                    <Form.Group className="mb-4">
                      <Form.Label>{language == 1 ? "Name" : "Nom"}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={
                          language == 1
                            ? "Enter your full name"
                            : "Entrez votre nom complet"
                        }
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required:
                            language == 1
                              ? "Full name is required"
                              : "Le nom complet est requis",
                        })}
                      />
                      {errors?.name && (
                        <Form.Text className="text-danger">
                          {errors?.name?.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    {/* EMAIL */}
                    <Form.Group className="mb-4">
                      <Form.Label>
                        {language == 1 ? "Email" : "E-mail"}
                      </Form.Label>
                      <Form.Control
                        type="email"
                        placeholder={
                          language == 1
                            ? "Enter your email address"
                            : "Entrez votre adresse e-mail"
                        }
                        {...register("email", {
                          required: "Email is required",
                          pattern: {
                            value: /^\S+@\S+$/i,
                            message:
                              language == 1
                                ? "Invalid email address"
                                : "Adresse e-mail invalide",
                          },
                        })}
                      />
                      {errors?.email && (
                        <Form.Text className="text-danger">
                          {errors?.email?.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    {/* PHONE */}
                    <Form.Group className="mb-4">
                      <Form.Label>
                        {language == 1 ? "Contact Number" : "Numéro de contact"}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={
                          language == 1
                            ? "Enter your phone number"
                            : "Entrez votre numéro de téléphone"
                        }
                        className={classNames({
                          "is-invalid": errors?.contact_no,
                        })}
                        {...register("contact_no", {
                          required:
                            language == 1
                              ? "Phone number is required"
                              : "Le numéro de téléphone est requis",
                        })}
                      />
                      {errors?.contact_no && (
                        <Form.Text className="text-danger">
                          {errors.contact_no.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    {/* MESSAGE */}
                    <Form.Group className="mb-4">
                      <Form.Label>
                        {language == 1 ? "Message" : "Message"}
                      </Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder={
                          language == 1
                            ? "Share your question or enquiry"
                            : "Partagez votre question ou votre demande"
                        }
                        className={classNames({
                          "is-invalid": errors?.message,
                        })}
                        {...register("message", {
                          required:
                            language == 1
                              ? "Message is required"
                              : "Le message est requis",
                        })}
                      />
                      {errors?.message && (
                        <Form.Text className="text-danger">
                          {errors.message.message}
                        </Form.Text>
                      )}
                    </Form.Group>

                    <Blue_btn btn_text="Get In Touch" type="submit" />
                  </Form>
                </div>

                <div className="social_icons_holder">
                  <Link
                    to="https://www.instagram.com/afigrp/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faInstagram}
                      className="social_icon"
                    />
                  </Link>

                  <Link
                    to="https://www.linkedin.com/company/afigroup"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faLinkedinIn}
                      className="social_icon"
                    />
                  </Link>

                  {/* <Link
                    to="https://www.facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faFacebookF}
                      className="social_icon"
                    />
                  </Link> */}

                  {/* <Link
                    to="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon
                      icon={faXTwitter}
                      className="social_icon"
                    />
                  </Link> */}

                  {/* <Link
                    to="https://www.youtube.com"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faYoutube} className="social_icon" />
                  </Link> */}
                </div>
              </div>
            </div>

            {/* RIGHT SIDE LOCATIONS */}
            <div className="col-lg-5 p-0 col-md-6">
              <div className="locations_wrapper">
                <h2 className="right_div_title">
                  {language == 1 ? "Get in touch" : "Contactez-nous"}
                </h2>

                <p className="right_div_subtitle">
                  {language == 1
                    ? "with our team for quick assistance and clear guidance."
                    : "avec notre équipe pour une assistance rapide et des conseils clairs."}
                </p>
                {/* COUNTRY CARD */}

                {getInTouch?.data?.map((value, index) => (
                  <div className="country_card">
                    <h5 className="country_name">{value?.name}</h5>
                    <p className="country_address">{value?.address}</p>
                    <div className="country_info">
                      <div>
                        <span>
                          {language == 1 ? "Call Us" : "Appelez-nous"}
                        </span>
                        <p>{value?.call_us}</p>
                      </div>
                      <div>
                        <span>
                          {language == 1 ? "Working Days" : "Jours ouvrables"}
                        </span>
                        <p>{value?.working_days}</p>
                      </div>
                      <div>
                        <span>
                          {language == 1 ? "Working Hrs" : "Heures de travail"}
                        </span>
                        <p>{value?.working_hour}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Get_started />

      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalSuccessShow(false)}
        message_text={"Submit Successfull"}
        animationData={successAnimation}
      />
    </>
  );
};

export default Contact_Us;
